import { atom } from 'jotai';

export const isMainMenu = atom(false);
export const currentSelectedCategory = atom(null);
